import { render, staticRenderFns } from "./Invoicing.vue?vue&type=template&id=3510a202&scoped=true&"
import script from "./Invoicing.vue?vue&type=script&lang=js&"
export * from "./Invoicing.vue?vue&type=script&lang=js&"
import style0 from "./Invoicing.vue?vue&type=style&index=0&id=3510a202&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510a202",
  null
  
)

export default component.exports